import { Validator } from 'vee-validate'
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
import Vuex from 'vuex'
import stateConfig from './config'

Vue.use(Vuex)
Vue.use(VueLocalStorage)

export default {
  [stateConfig.LOGIN]: function(state) {
    state.loading = true
  },
  [stateConfig.LOGIN_SUCCESS]: function(state) {
    state.isLoggedIn = true
    state.loading = false
  },
  [stateConfig.LOGIN_FAIL]: function(state) {
    state.loading = false
  },
  [stateConfig.LOGOUT]: function(state) {
    state.isLoggedIn = false
    state.loading = false
  },
  [stateConfig.SELECT_BOT]: function(state) {
    state.isSelectedBot = true
  },
  [stateConfig.LOADING]: function(state) {
    state.loading = !state.loading
  },
  [stateConfig.CLEAR_LOADING]: function(state) {
    state.loading = false
  },
  [stateConfig.SIDEBAR]: function(state) {
    state.openSidebar = !state.openSidebar
  },
  [stateConfig.SELECT_NEW_BOT]: function(state, bot) {
    state.selectedBot = bot
  },
  [stateConfig.UPDATE_SETTING]: function(state, setting) {
    state.setting = setting
  },
  [stateConfig.UPDATE_WELCOME_MESSAGE]: function(state, welcomeMessage) {
    state.welcomeMessage = welcomeMessage
  },
  [stateConfig.UPDATE_MODAL_WELCOME]: function(state, value) {
    if (value) {
      state.showModalWelcome = true
      Vue.localStorage.set('showModalWelcome', true)
    } else {
      state.showModalWelcome = undefined
      Vue.localStorage.remove('showModalWelcome')
    }
  },
  [stateConfig.SET_LANG](state, payload) {
    Vue.i18n.set(payload)
    Validator.localize(payload)
  },
  [stateConfig.SET_FLOW_ID](state, payload) {
    state.selectedFlow = payload
  },
  [stateConfig.SET_COPY_NODE](state, payload) {
    if (payload) {
      state.copyNodes = payload
      Vue.localStorage.set('copyNodes', JSON.stringify(payload))
    } else {
      state.copyNodes = []
      Vue.localStorage.remove('copyNodes')
    }
  },
  ['SET_ADMIN_LIST'](state, payload) {
    state.adminList = payload
  },
  ['SET_PERSISTENT_MENU'](state, payload) {
    if (payload) {
      state.persistent_menu = payload
    } else {
      state.persistent_menu = []
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js